import { create } from 'zustand';

type ViewMode = 'admin' | 'inspector';

interface ViewModeState {
  viewMode: ViewMode;
  setViewMode: (mode: ViewMode) => void;
}

export const useViewModeStore = create<ViewModeState>((set) => ({
  viewMode: 'admin',
  setViewMode: (mode: ViewMode) => set({ viewMode: mode }),
}));
